import React from 'react';

export default ({action, title}) => (
  <div onClick={action} className="add-section">
    <i className="fa fa-plus-square-o"></i>
    <span className="add-section__title">{title}</span>
  </div>
)
